import React, { useContext, useEffect, useMemo, useState } from 'react'
import {
    Alert,
    Badge,
    Box,
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Radio,
    RadioGroup,
    Select,
    Switch,
    Tooltip
} from '@mui/material'
import { MobileDatePicker } from '@mui/x-date-pickers'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import moment from 'moment'
import { api } from '../../../services/Main/Api'
import Context from '../../../contexts/Context'
import Masks from '../../../components/Shared/Masks'

function RentContractFeeForm({
                                 open,
                                 onClose,
                                 onSaved,
                                 rentId,
                             }) {
    const { screenRefresh, setScreenRefresh } = useContext(Context)

    // ---------- STATE DO FORM ----------
    const [errors, setErrors] = useState(null);

    const [year, setYear] = useState(moment().format('YYYY'));
    const [month, setMonth] = useState(moment().format('MM'));

    const [value, setValue] = useState(0);
    const [valueFormated, setValueFormated] = useState("R$ 0,00");
    const [category, setCategory] = useState("");
    const [categoryTag, setCategoryTag] = useState("");

    const [invoiceRule, setInvoiceRule] = useState("INVOICE_SUM_VALUE");
    const [transferRule, setTransferRule] = useState("NO_ACTION");

    const [categoryChoices, setCategoryChoices] = useState([]);
    const [valueTypeChoices, setValueTypeChoices] = useState([]);
    const [valueType, setValueType] = useState("FIXED_VALUE");
    const [percentageRuleChoices, setPercentageRuleChoices] = useState(null);
    const [percentageRule, setPercentageRule] = useState("RENT_TOTAL");
    const [recurringTypeChoices, setRecurringTypeChoices] = useState([]);

    const [recurring, setRecurring] = useState(false);
    const [recurringType, setRecurringType] = useState("EVERYDAY");
    const [recurringCustom, setRecurringCustom] = useState(48);
    const [recurringEndYear, setRecurringEndYear] = useState(null);
    const [recurringEndMonth, setRecurringEndMonth] = useState(null);
    const [recurringText, setRecurringText] = useState("Sem data de termino");

    const [installment, setInstallment] = useState(false);
    const [installmentStart, setInstallmentStart] = useState(0);
    const [installmentNumber, setInstallmentNumber] = useState(2);

    const [description, setDescription] = useState("");
    const [payment, setPayment] = useState(false);
    const [dueDatePayment, setDueDatePayment] = useState(null);

    const [includeIncomeTax, setIncludeIncomeTax] = useState(false);
    const [proportionalCalculation, setProportionalCalculation] = useState(false);
    const [singleInstallmentPayment, setSingleInstallmentPayment] = useState(false);

    const [isSaving, setIsSaving] = useState(false);

    const [categoryId, setCategoryId] = useState('');
    const [selectedCategory, setSelectedCategory] = useState(null);


    // DAILY / PER-DAY
    const DAYS_OF_WEEK = useMemo(()=>[
        { value: 1, label: "Segunda-feira" },
        { value: 2, label: "Terça-feira" },
        { value: 3, label: "Quarta-feira" },
        { value: 4, label: "Quinta-feira" },
        { value: 5, label: "Sexta-feira" },
        { value: 6, label: "Sábado" },
        { value: 7, label: "Domingo" },
    ], [])
    const [perDaySelected, setPerDaySelected] = useState([1,2,3,4,5,6,7]);
    const [startDate, setStartDate] = useState(moment().toDate());
    const [endDate, setEndDate] = useState(null);

    const SelectMenuProps = useMemo(()=>({
        PaperProps: { style: { maxHeight: 48 * 4.5 + 8, width: 280 } },
    }), [])

    const range = (start, end) => Array.from({ length: end - start + 1 }, (_, i) => start + i)
    const [installmentRange] = useState(range(1, 96));

    // formatador -> numérico do campo monetário
    useEffect(()=>{
        setValue(parseInt((valueFormated || '').replace(/[^0-9]/g, '')) || 0)
    }, [valueFormated])

    // carregar choices
    const handleChoices = () => {
        let params = { rent_contract: rentId }
        api.get("/rent-contract/choices/", {params}).then(response => {
            setCategoryChoices(response.data.category_choices || [])
            setInvoiceRuleChoices(response.data.invoice_choices || [])
            setTransferRuleChoices(response.data.transfer_choices || [])
            setRecurringTypeChoices(response.data.recurring_type_choices || [])
            setValueTypeChoices(response.data.value_type_choices || [])
            setPercentageRuleChoices(response.data.percentage_rule_choices || [])
        }).catch(console.log)
    }

    const [invoiceRuleChoices, setInvoiceRuleChoices] = useState([]);
    const [transferRuleChoices, setTransferRuleChoices] = useState([]);

    useEffect(() => {
        if (open) {
            handleChoices()
            // reset básico ao abrir
            setErrors(null)
        }
    }, [open])

    // texto de recorrência
    useEffect(()=>{
        const choices = {
            THREE_MONTHS: 3,
            SIX_MONTHS: 6,
            TWELVE_MONTHS: 12,
            TWENTY_FOUR_MONTHS: 24,
            THIRTY_MONTHS: 30,
            CUSTOM: recurringCustom,
        }
        if (recurringType === "EVERYDAY"){
            setRecurringText(`Sem data de término`)
            setRecurringEndYear(null)
            setRecurringEndMonth(null)
        }else{
            let months = choices[recurringType]
            if (months !== undefined){
                let end = moment(`${year}-${month}`, 'YYYY-MM').add(months, 'months');
                setRecurringText(`Recorrente até ${end.format("MMMM [de] YYYY")}`)
                setRecurringEndYear(end.format("YYYY"))
                setRecurringEndMonth(end.format("MM"))
            } else {
                setRecurringText("")
            }
        }
    }, [recurringType, year, month, recurringCustom])

    const handlePerDayChange = (event) => {
        const v = event.target.value;
        setPerDaySelected(typeof v === "string" ? v.split(",").map(Number) : v);
    };

    function resetFields() {
        setValue(0)
        setValueFormated("0,00")
        setRecurring(false)
        setInstallment(false)
        setInvoiceRule("INVOICE_SUM_VALUE")
        setTransferRule("NO_ACTION")
        setInstallmentNumber(2)
        setInstallmentStart(0)
        setCategory("")
        setCategoryTag("")
        setRecurringCustom(48)
        setRecurringType("EVERYDAY")
        setDescription("")
        setPayment(false)
        setDueDatePayment(null)
        setErrors(null)
        setPerDaySelected([1,2,3,4,5,6,7])
        setIncludeIncomeTax(false)
        setProportionalCalculation(false)
        setSingleInstallmentPayment(false)
        setYear(moment().format('YYYY'))
        setMonth(moment().format('MM'))
        setStartDate(moment().toDate())
        setEndDate(null)
    }

    const handleClose = () => {
        onClose?.()
        // não limpa agressivo ao fechar, mas pode:
        // resetFields()
    }

    function handleSaveFee () {
        setIsSaving(true)

        const reference_date = moment(`${year}-${month}`, 'YYYY-MM').format("YYYY-MM-DD");

        const payload = {
            value,
            year,
            month,
            category: categoryTag,
            category_fee: categoryId, // ← envia TAG no lugar de ID
            recurring,
            description,
            payment,
            payment_due_date: dueDatePayment,
            installment_start: null,
            installments: false,
            invoice_rule: invoiceRule,
            transfer_rule: transferRule,
            rent_contract: rentId,
            recurring_type: null,
            recurring_end_month: null,
            recurring_end_year: null,
            reference_date,
            include_income_tax: includeIncomeTax,
            apply_proportional_calculation: proportionalCalculation,
            single_installment_payment: singleInstallmentPayment,
        };

        if (installment === true) {
            payload.installment = installment;
            payload.installment_start = installmentStart;
            payload.installment_total_number = installmentNumber;
        }

        if (recurring === true) {
            payload.recurring_type = recurringType;
            if (recurringType !== 'EVERYDAY') {
                payload.recurring_end_month = recurringEndMonth;
                payload.recurring_end_year = recurringEndYear;
            }
        }

        if (categoryTag === "ADMINISTRATIVE_FEE") {
            payload.value_type = valueType;
            payload.percentage_rule = percentageRule;
        }

        if (recurringType === 'PER_DAY' && perDaySelected.length > 0) {
            payload.recurring_days = perDaySelected; // ex.: [1,2,3,4,5]
            // datas (quando DAILY)
            if (startDate) payload.start_date = moment(startDate).format('YYYY-MM-DD')
            if (endDate) payload.end_date = moment(endDate).format('YYYY-MM-DD')
        }

        api.post("/rent-contract/fee/", payload)
            .then(() => {
                // feedback no pai
                onSaved?.()
                resetFields()
                onClose?.()
            })
            .catch((error) => {
                console.log(error);
                setErrors(error?.response?.data);
            })
            .finally(() => {
                setIsSaving(false);
            });
    }

    return (
        <Dialog
            fullWidth
            maxWidth='md'
            open={open}
            scroll='body'
            onClose={handleClose}
        >
            <DialogTitle>Criar Cobrança</DialogTitle>
            <Divider/>

            <DialogContent>
                <Box component="form" noValidate>
                    <Grid container spacing={2} mt={0}>
                        <Grid item xs={12} md={12}>
                            { errors && <Alert severity="error" sx={{mb:2}}>
                                {errors?.non_field_errors?.map((error, index) => (
                                    <div key={index}>{error}</div>
                                ))}
                            </Alert> }
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth required>
                                <InputLabel id="category-select-label">Categoria</InputLabel>
                                <Select
                                    labelId="category-select-label"
                                    id="category-select"
                                    value={categoryId}                // <-- usar id aqui
                                    onChange={(event)=> {
                                        const id = event.target.value;  // <-- vem como id
                                        setCategoryId(id);

                                        const found = categoryChoices.find(c => c.id === id); // pega objeto
                                        setSelectedCategory(found || null);

                                        const rules = found?.rules || {};
                                        setCategoryTag(found?.tag || '');
                                        setInvoiceRule(rules.invoice_rule || "INVOICE_SUM_VALUE");
                                        setTransferRule(rules.transfer_rule || "NO_ACTION");
                                        setRecurring(!!rules.recurring);
                                        setRecurringType("TWELVE_MONTHS");

                                        if(found?.tag === 'RENT_FEE') {
                                            setYear(moment(found.start_date).format('YYYY'));
                                            setMonth(moment(found.start_date).format('MM'));
                                        }
                                    }}
                                    input={<OutlinedInput label="Categoria" />}
                                >
                                    {categoryChoices.map((item) => (
                                        <MenuItem key={item.id} value={item.id}>   {/* <-- value é id */}
                                            {item.value}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Valor */}
                        {categoryTag === "ADMINISTRATIVE_FEE" && (
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth required>
                                    <InputLabel id="value-type-select-label">Tipo do valor</InputLabel>
                                    <Select
                                        labelId="value-type-select-label"
                                        id="valuetype-select"
                                        value={valueType}
                                        onChange={(event)=> {
                                            const v = event.target.value
                                            setValueType(v)
                                            if (v === "PERCENTAGE_VALUE"){
                                                setValue(10)
                                                setRecurring(true)
                                                setRecurringType("EVERYDAY")
                                            } else {
                                                setRecurringType("TWELVE_MONTHS")
                                            }
                                        }}
                                        input={<OutlinedInput label="Tipo do valor" />}
                                    >
                                        {valueTypeChoices.map((item, index) => (
                                            <MenuItem key={index} value={item.id}>{item.value}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        )}

                        {categoryTag === "ADMINISTRATIVE_FEE" && valueType === "PERCENTAGE_VALUE" ? (
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth required>
                                    <InputLabel>Valor %</InputLabel>
                                    <OutlinedInput
                                        onChange={(e)=> setValue(e.target.value)}
                                        value={value}
                                        label="Valor %"
                                    />
                                </FormControl>
                            </Grid>
                        ) : (
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth required>
                                    <InputLabel>Valor</InputLabel>
                                    <OutlinedInput
                                        onChange={(e)=> setValueFormated(Masks?.money(e.target.value))}
                                        value={valueFormated}
                                        label="Valor"
                                    />
                                </FormControl>
                            </Grid>
                        )}

                        {/* Mês de cobrança (oculto em alguns casos) */}
                        { !(categoryTag === "RENT_FEE" || recurringType === "DAILY") && (
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <MobileDatePicker
                                        openTo='month'
                                        views={['year', 'month']}
                                        label="Mês de Cobrança"
                                        value={moment(`${year}-${month}`, 'YYYY-MM').toDate()}
                                        onChange={(e)=> {
                                            setYear(moment(e).format('YYYY'))
                                            setMonth(moment(e).format('MM'))
                                        }}
                                        slotProps={{
                                            field: { clearable: false, onClear: () => {} },
                                            textField: { size: "large" }
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        )}

                        <Grid item xs={12} md={9}>
                            <FormControl fullWidth>
                                <OutlinedInput
                                    id="fee-description"
                                    placeholder="Descrição"
                                    value={description || ''}
                                    onChange={(e)=> setDescription(e.target.value)}
                                    multiline
                                    minRows={1}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>

            <Divider />
            <DialogTitle>Regras</DialogTitle>
            <DialogContent>
                <Grid container spacing={2} mt={.5}>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <InputLabel id="invoice-select-label">Fatura</InputLabel>
                            <Select
                                labelId="invoice-select"
                                id="invoice-select"
                                value={invoiceRule}
                                label="Fatura"
                                disabled={category === "ADMINISTRATIVE_FEE"}
                                onChange={(e)=> setInvoiceRule(e.target.value)}
                            >
                                {invoiceRuleChoices.map((item, index) => (
                                    <MenuItem key={index} value={item.id}>{item.value}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <InputLabel id="transfer-select-label">Repasse</InputLabel>
                            <Select
                                labelId="transfer-select"
                                id="transfer-select"
                                value={transferRule}
                                label="Repasse"
                                onChange={(e)=> setTransferRule(e.target.value)}
                            >
                                {transferRuleChoices.map((item, index) => (
                                    <MenuItem key={index} value={item.id}>{item.value}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <FormControl fullWidth>
                            <FormLabel sx={{color:"#333"}}>
                                Incluir no IRRF <Tooltip title="Esse campo inclui ou não o valor na dedução do Imposto de Renda Retido na Fonte."><InfoOutlinedIcon fontSize="12" /></Tooltip>
                            </FormLabel>
                            <RadioGroup
                                row
                                value={includeIncomeTax}
                                onChange={(e)=> setIncludeIncomeTax(e.target.value === 'true')}
                            >
                                <FormControlLabel value={true} control={<Radio />} label="Sim" />
                                <FormControlLabel value={false} control={<Radio />} label="Não" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <FormControl fullWidth>
                            <FormLabel sx={{color:"#333"}}>
                                Cobrança Proporcional <Tooltip title="Válido para calcular proporcionalidade no primeiro mês de contrato."><InfoOutlinedIcon fontSize="12" /></Tooltip>
                            </FormLabel>
                            <RadioGroup
                                row
                                value={proportionalCalculation}
                                onChange={(e)=> setProportionalCalculation(e.target.value === 'true')}
                            >
                                <FormControlLabel value={true} control={<Radio />} label="Sim" />
                                <FormControlLabel value={false} control={<Radio />} label="Não" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>

                    { categoryTag === "ADMINISTRATIVE_FEE" && valueType === "PERCENTAGE_VALUE" && (
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth required>
                                <InputLabel id="percentage-rule-label">Cálculo baseado em</InputLabel>
                                <Select
                                    labelId="percentage-rule-label"
                                    id="percentage-rule-select"
                                    value={percentageRule}
                                    onChange={(e)=> setPercentageRule(e.target.value)}
                                    input={<OutlinedInput label="Cálculo baseado em" />}
                                >
                                    {percentageRuleChoices?.map((item, index) => (
                                        <MenuItem key={index} value={item.id}>{item.value}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}
                </Grid>
            </DialogContent>

            <Divider />
            <DialogTitle sx={{display:"flex", justifyContent:"space-between"}}>
                Cobrança Recorrente
                <Switch
                    checked={recurring}
                    onChange={() => setRecurring(!recurring)}
                    name="recurringBilling"
                    color="primary"
                    disabled={(installment || valueType === "PERCENTAGE_VALUE")}
                />
            </DialogTitle>

            {recurring && (
                <DialogContent>
                    <Grid container spacing={2} mt={.5}>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                {recurringType === "CUSTOM" ? (
                                    <>
                                        <InputLabel>Número de meses</InputLabel>
                                        <OutlinedInput
                                            placeholder="Número de meses"
                                            label="Número de meses"
                                            value={recurringCustom}
                                            onChange={(e)=> setRecurringCustom(e.target.value)}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <InputLabel id="transfer-select-label">Recorrência</InputLabel>
                                        <Select
                                            labelId="transfer-select"
                                            id="transfer-select"
                                            value={recurringType}
                                            label={"Recorrência"}
                                            onChange={(e)=> setRecurringType(e.target.value)}
                                        >
                                            {recurringTypeChoices.map((item, index) => (
                                                <MenuItem key={index} value={item.id}>{item.value}</MenuItem>
                                            ))}
                                        </Select>
                                    </>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} sx={{display:"flex", alignItems:"center", justifyContent:"start", alignContent: "center"}}>
                            <Box >
                            <Chip size={"small"} label={recurringText} />
                            </Box>
                        </Grid>


                    </Grid>
                </DialogContent>
            )}

            <Divider />
            <DialogTitle sx={{display:"flex", justifyContent:"space-between"}}>
                Parcelamento
                <Switch
                    checked={installment}
                    onChange={() => setInstallment(!installment)}
                    name="installment"
                    color="primary"
                    disabled={recurring}
                />
            </DialogTitle>

            {installment && (
                <DialogContent>
                    <Grid container spacing={2} mt={.5}>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth >
                                <InputLabel id="installment-select-label">Parcelar em</InputLabel>
                                <Select
                                    labelId="installment-select"
                                    id="installment-select"
                                    value={installmentNumber}
                                    label="Parcelar em"
                                    onChange={(e)=> setInstallmentNumber(e.target.value)}
                                >
                                    {installmentRange.map((item, index) =>
                                        <MenuItem key={index} value={item}>{item}x</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth >
                                <InputLabel id="installment-start-label">Iniciar na Parcela</InputLabel>
                                <Select
                                    labelId="installment-start-label"
                                    id="installment-start"
                                    value={installmentStart}
                                    label="Iniciar Parcela em"
                                    onChange={(e)=> setInstallmentStart(e.target.value)}
                                >
                                    <MenuItem value={0}>Selecione</MenuItem>
                                    {installmentRange.map((item, index) =>
                                        <MenuItem key={index} value={item}>{item}ª Parcela</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>
            )}

            <Divider />
            <DialogTitle sx={{display:"flex", justifyContent:"space-between"}}>
                <Box>
                    Encargo Locatício
                    <Badge sx={{ fontSize: 10, padding: 0, marginLeft:'1.5rem' }} badgeContent={'Novo'} size='small' variant="string" color="primary" />
                </Box>
                <Switch
                    checked={payment}
                    onChange={() => setPayment(!payment)}
                    name="payment"
                    color="primary"
                    disabled={(category === "RENT_FEE" ||  category === "ADMINISTRATIVE_FEE" ||  category === "INTERMADIATION_FEE")}
                />
            </DialogTitle>

            {payment && (
                <DialogContent>
                    <Box>Gerencie e controle seus encargos locatícios do mês.</Box>
                    <Grid container spacing={2} mt={0.5}>
                        <Grid item xs={12} md={6}>
                            <Grid container>
                                <Grid item xs={6} sm={5}>
                                    <FormControl fullWidth >
                                        <InputLabel id="duedate-select-label">Dia do vencimento</InputLabel>
                                        <Select
                                            labelId="duedate-select-label"
                                            id="duedate-select"
                                            value={dueDatePayment}
                                            label="Dia do vencimento"
                                            onChange={(e)=> setDueDatePayment(e.target.value)}
                                        >
                                            <MenuItem value={null}>Não informar</MenuItem>
                                            {[...Array(31).keys()].map((i) =>
                                                <MenuItem key={i} value={i + 1}>{i + 1}</MenuItem>
                                            )}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={6} sm={5} sx={{ ml: 8 }}>
                                    {installment && (
                                        <FormControl fullWidth >
                                            <FormLabel sx={{color:"#333"}}>
                                                Pagar em Cota Única
                                                <Tooltip title="Define se o encargo será pago em cota única, enquanto a cobrança é parcelada.">
                                                    <InfoOutlinedIcon fontSize="12" />
                                                </Tooltip>
                                            </FormLabel>
                                            <RadioGroup
                                                row
                                                value={singleInstallmentPayment}
                                                onChange={(e)=> setSingleInstallmentPayment(e.target.value === 'true')}
                                            >
                                                <FormControlLabel value={true} control={<Radio />} label="Sim" />
                                                <FormControlLabel value={false} control={<Radio />} label="Não" />
                                            </RadioGroup>
                                        </FormControl>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
            )}

            <Divider />
            <DialogActions sx={{display:"flex", justifyContent:"space-between", p: "2rem 1rem"}}>
                <Button variant="text" color="secondary" onClick={handleClose}>Cancelar</Button>
                <Button variant="contained" disabled={isSaving} color="primary" onClick={() => {
                    handleSaveFee();
                    setScreenRefresh(true);
                }}>
                    {isSaving ? "Salvando" : "Salvar"}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default RentContractFeeForm
